import { Route } from "react-router-dom";
import PermissionRoute from "./permissionRoute";
import RoleRoute from "./roleRoute";
import UserRoute from "./userRoute";

const ConfigRoutes = () => {
  return (
    <Route path="config">
      {PermissionRoute()}
      {RoleRoute()}
      {UserRoute()}
    </Route>
  );
};

export default ConfigRoutes;
